import type { ColumnDef } from '@tanstack/vue-table'
import { renderHeaderWithSorting } from '../utils/renderHeaderWithSorting'
import type { ColumnList } from '~~/src/types/library'
import type { User } from '~~/src/types/user'

export const COLUMNS_DEFINITION: ColumnDef<ColumnList>[] = [
  {
    accessorKey: 'title',
    enableHiding: false,
    header: ({ column }) => renderHeaderWithSorting(column),
    cell: ({ row }) => h('div', { class: 'capitalize title' }, row.getValue('title')),
  },
  {
    id: 'user',
    accessorFn: (row) => {
      const user = row.user as User
      return user?.id
    },
    filterFn: (row, columnId, filterValue) => {
      return row.getValue(columnId) === filterValue
    },
    header: ({ column }) => renderHeaderWithSorting(column),
    cell: ({ row }) => {
      const user = row.getValue('user') as User
      return h('div', { class: 'capitalize author' }, user?.name || '')
    },
  },
  {
    id: 'elementalTypeId',
    accessorKey: 'elementalTypeId',
    enableSorting: true,
    sortingFn: 'basic',
    filterFn: (row, columnId, filterValue) => {
      const rowValue = row.getValue(columnId)
      return Array.isArray(filterValue)
        ? filterValue.includes(rowValue)
        : rowValue === filterValue
    },
    header: ({ column }) => renderHeaderWithSorting(column),
    cell: ({ row }) => {
      return h('div', { class: 'text-right font-medium' }, row.getValue('elementalTypeId'))
    },
  },
  {
    accessorKey: 'createdAt',
    header: ({ column }) => renderHeaderWithSorting(column),
    cell: ({ row }) => {
      const date = row.getValue('createdAt')
      const formatted = date ? formatDateToShortUS(new Date(date)) : ''
      return h('div', { class: 'date' }, formatted)
    },
    sortingFn: 'datetime',
  },
  {
    accessorKey: 'updatedAt',
    header: ({ column }) => renderHeaderWithSorting(column),
    cell: ({ row }) => {
      const date = row.getValue('updatedAt')
      const formatted = date ? formatDateToShortUS(new Date(date)) : ''
      return h('div', { class: 'date' }, formatted)
    },
    sortingFn: 'datetime',
  },
]
